import React, { ReactNode } from 'react';
import { Box } from '../Box';

export interface CarouselSlideProps {
    children?: ReactNode;
    spacing?: number;
    width?: string; //defaults to 'auto' for variable widths
}

export const CarouselSlide = ({ width, children, spacing }: CarouselSlideProps) => {
    return (
        <Box
            sx={{
                width: width ?? 'auto',
                minWidth: 0,
                flex: `0 0 ${width ?? 'auto'}`,
                paddingLeft: spacing ?? 2,
                '&:first-of-type': {
                    paddingLeft: 0
                },
                height: 'fit-content'
            }}
        >
            {children}
        </Box>
    );
};
